import React from 'react';
import CommentCardHeader from '../../../atoms/comments/card-header';
import styles from './styles.scss';
import AvatarCustom from '../../../atoms/avatar/AvatarCustom';
import Utils from '../../../../utils/comments-utils';
import { Comment } from '../../../../utils/comments/types';

interface ReplyCardProps {
    reply?: Comment,
    avatarsrc?: string,
}

/* CommentCard displays a single comment card */
const ReplyCard = function ReplyCard(
    { reply, avatarsrc = '' }: ReplyCardProps
) {
    if (!reply) {
        return null;
    }

    return (
        <>
            <CommentCardHeader
                className={`${styles['reply-comment']} ${styles['reply-avatar']}`}
                avatar={(
                    <AvatarCustom author={reply.Author ?? ''} avatarsrc={avatarsrc} />
                )}
                subheader={(
                    <div className={`${styles.row} ${styles['created-text']}`}>
                        {Utils.CalculateTimeDiff(reply.Created)}
                    </div>
                )}
            />
            <div className={styles['reply-content']}>
                {reply.MessageText}
            </div>
        </>
    );
};

export default ReplyCard;
